export class W3cWSClient {
  constructor({ 
    address, 
    headers, connectionTimeout, certification, withCredentials, onPing, onPong, onConnect, onDisconnect, onError, events }) {
    this._socket = null
    this.connection = null
    this._isConnected = false
    this.address = address
    this.events = events
    this.onPing = onPing
    this.onPong = onPong
    this.onConnect = onConnect
    this.onDisconnect = onDisconnect
    this.onError = onError
    this.option = {
      extraHeaders: headers,
      withCredentials,
      certification
    }
  }

  connect() {
    if (this._socket) {
      this._socket.disconnect()
    }

    this._socket = new WebSocket(this.address)

    this._socket.addEventListener('open', (event) => {
      this._isConnected = true
      this.connection = this._socket
      if (this.onConnect) {
        this.onConnect(this)
      }
    })

    this._socket.addEventListener('message', (event) => {
      const receivedMessage = event.data
      const message = receivedMessage && receivedMessage.utf8Data ? receivedMessage.utf8Data : receivedMessage
      let jsonMessage = ''
      try {
        jsonMessage = JSON.parse(message)
      } catch (e) {
        jsonMessage = message
      }

      if (jsonMessage.type) {
        this.events.dispatch(jsonMessage.type, this, jsonMessage)
      }

      if (jsonMessage === 'pong') {
        if (this.onPong) {
          this.onPong()
        }
      } else if (jsonMessage === 'ping') {
        if (this.onPing) {
          this.onPing()
        }
      } else {
        this.events.dispatch('*', this, jsonMessage)
      }
    })

    this._socket.addEventListener('error', (...args) => {
      if (this.onError) {
        this.onError(...args)
      }
    })

    this._socket.addEventListener('close', (event) => {
      this._isConnected = false
      if (this.onDisconnect) {
        this.onDisconnect()
      }
    })

    return this
  }

  isConnected() {
    const STATE = {
      CONNECTING: 0,
      OPEN: 1,
      CLOSING: 2,
      CLOSED: 3
    }
    return this.connection && STATE.OPEN === this.connection.readyState
  }

  disconnect() {
    try {
      if (!this.connection) {
        return
      }
      this.connection.close()
      return
    } catch (e) {
      console.error(e)
      return
    }
  }

  emitRaw(...args) {
    if (this.connection && this.isConnected) {
      this.connection.send(...args)
    }
  }

  pong() {
    if (!this._socket) {
      return
    }
    this._socket.send('pong')
  }

  ping() {
    if (!this._socket) {
      return
    }
    this._socket.send('ping')
  }

  emit(payloadOrEventType, miscPayload) {
    if (!this.connection) {
      return
    }

    if (typeof payloadOrEventType === 'string') {
      const eventType = payloadOrEventType
      const payload = miscPayload
      return this.connection.send(JSON.stringify({ ...payload, type: eventType }))
    } else if (typeof payloadOrEventType === 'object') {
      const payload = payloadOrEventType
      return this.connection.send(JSON.stringify({ ...payload }))
    }
  }

  addEventListener(...args) {
    return this.events.addEventListener(...args)
  }

  removeEventListener(...args) {
    return this.events.removeEventListener(...args)
  }

  removeEventListenerAll(...args) {
    return this.events.removeEventListenerAll(...args)
  }
}

export const BrowserWSClient = W3cWSClient
